import { gql } from '@apollo/client';
export const holidays = gql `
  {
    holidays {
      day
    }
  }
`;
//# sourceMappingURL=holidays.js.map